module.exports = __webpack_public_path__ + "assets/pdf/Communique-de-presse-L.D.B.e26b4ef5.pdf";